<template>
  <component
    :is="isLink ? 'router-link' : 'div'"
    :to="isLink ? item.route : undefined"
    class="col-12 col-sm-6 col-md-4 col-lg-3 list-complete-item text-black"
    data-test-id="menu-item-card"
  >
    <q-card
      class="cursor-pointer position-relative"
      style="min-height: 100px;"
      flat
      bordered
      horizontal
      @click="$emit('click')"
    >
      <q-card-section
        horizontal
        class="q-pa-xs"
      >
        <q-item class="col q-pr-none">
          <q-item-label>
            <q-icon
              :name="item.icon || defaultIcon"
              size="md"
              class="q-pr-sm"
            />
          </q-item-label>

          <q-item-section class="col">
            <q-item-label
              style="font-size: 18px;"
            >
              {{ item.label }}
            </q-item-label>
            <q-item-label
              class="ellipsis-3-lines"
              caption
            >
              {{ item.description }}
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          v-if="isLink"
          class="col-auto q-px-xs q-py-none items-center"
        >
          <q-btn
            class="items-center"
            :icon="isItemFavorite ? 'star' : 'star_outline'"
            round
            dense
            size="lg"
            :text-color="isItemFavorite ? 'yellow' : null"
            :loading="isSavingFavorite"
            @click.prevent="addFavorite(item)"
          >
            <q-tooltip>
              {{ $t('user.actions.addToFavorites') }}
            </q-tooltip>
          </q-btn>
        </q-item>
      </q-card-section>
      <q-badge
        v-if="$_.isNumber(notificationCount) && notificationCount > 0"
        rounded
        color="primary"
        :label="notificationCount"
        floating
      />
    </q-card>
  </component>
</template>

<script>
export default {
  name: 'MenuItemCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    defaultIcon: {
      type: String,
      required: true
    },
    notificationCount: {
      type: Number,
      required: false,
      default: null
    }
  },
  emits: ['click'],
  data () {
    return {
      isSavingFavorite: false
    }
  },
  context: ['currentUser'],
  computed: {
    isLink () {
      return !!this.item.route && !this.item.method
    },
    isItemFavorite () {
      return this.currentUser.adminMenuFavorites.includes(this.item.route)
    }
  },
  methods: {
    async addFavorite (item) {
      this.isSavingFavorite = true
      if (this.isItemFavorite) {
        this.currentUser.adminMenuFavorites = _.without(this.currentUser.adminMenuFavorites, item.route)
      } else {
        this.currentUser.adminMenuFavorites.push(item.route)
      }
      await this.currentUser.save()
      this.isSavingFavorite = false
    }
  }
}
</script>

<style lang="scss" scoped>
.list-complete-item {
  transition: all 0.5s;
  display: inline-block;
  text-decoration: none;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
